import React from 'react'
import { ReactComponent as PmrGreen } from '../../../../../assets/pmr-green-big.svg';
import { ReactComponent as PmrYellow } from '../../../../../assets/pmr-yellow-big.svg';
import { ReactComponent as PmrRed } from '../../../../../assets/pmr-red-big.svg';
import { DONE_DISBURSEMENT_KEY, YEAR_PROJECTION_DISBURSEMENT_KEY } from '../../utils/Constants/ProjectReportConstants';

export interface NomItemProps {
    key?: string;
    title: string;
    icon: any;
    description?: any;
    titleCompose?: string;
}

export enum RiskStatus {
    Low,
    MediumLow,
    MediumHigh,
    High
}

export const dataSteps: NomItemProps[] = [
    {
        title: 'satisfactory',
        icon: <PmrGreen width={12} />
    },
    {
        title: 'alert',
        icon: <PmrYellow width={12} />
    },
    {
        title: 'problem',
        icon: <PmrRed width={12} />
    },

]

export const dataProgress: NomItemProps[] = [
    {
        title: 'justified',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#3f51b5',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
    {
        title: 'pending',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#b6bce2',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
]

export const disbursementProgress: NomItemProps[] = [
    {
        key: YEAR_PROJECTION_DISBURSEMENT_KEY,
        title: YEAR_PROJECTION_DISBURSEMENT_KEY,
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#D0D5E0',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
    {
        key: DONE_DISBURSEMENT_KEY,
        title: DONE_DISBURSEMENT_KEY,
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#416DBC',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
]

export const riskStatus: NomItemProps[] = [
    {
        key: 'low',
        title: 'low',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#6DD983',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
    {
        key: 'mediumLow',
        title: 'medium-low',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#E7CE00',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
    {
        key: 'mediumHigh',
        title: 'medium-high',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#FDAC41',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
    {
        key: 'high',
        title: 'high',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#F06D6D',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    }
]

export const acquisitionProductStatusColors = {
    backgroundColor: {
        completed: '#6ec7f0ff',
        pending: '#416DBC',
        unassign: '#D0D5E0',
    },
    color: {
        completed: '#ffffffff',
        pending: '#ffffffff',
        unassign: '#000000ff',
    }
};

export const financialAdvanceStatusColors = {
    backgroundColor: {
        disbursment: '#236BFF',
        committed: '#FDAC41',
        pending: '#D0D5E0',
    },
    color: {
        disbursment: '#ffffffff',
        committed: '#ffffffff',
        pending: '#000000ff',
    }
};

export const acquisitionProductStatus: NomItemProps[] = [
    {
        title: 'last_contracted',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: acquisitionProductStatusColors.backgroundColor.completed,
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
    {
        title: 'pending',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: acquisitionProductStatusColors.backgroundColor.pending,
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
    {
        title: 'last_not_assigned_in_plan',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: acquisitionProductStatusColors.backgroundColor.unassign,
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
]

export const supervitionProgress: NomItemProps[] = [
    {
        title: 'projected_progress',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#b6bce2',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
    {
        title: 'actual_progress',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#3f51b5',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
]

export const transactionalResources: NomItemProps[] = [
    {
        title: 'spent',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#FDAC41',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
    {
        title: 'committed_supervision',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#00CFDD',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
    {
        title: 'available',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#3f51b5',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
]

export const evolutionDisbursmentProgress: NomItemProps[] = [
    {
        title: 'original_projection',
        icon: <span
            style={{
                backgroundColor: '#5A6A8A',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
                width: '13px',
                height: '3px'
            }}
        ></span>
    },
    {
        title: 'amount_disbursed',
        icon: <span
            className="bullet"
            style={{
                backgroundColor: '#538CFF',
                display: 'inline-flex',
                marginLeft: 5,
                marginRight: 5,
            }}
        ></span>
    },
]

export const trasactionalResourcesData = {
    labels: ["VPC", "VPS", "FMP", "ESG", "CT"],
    datasets: [
        {
            backgroundColor: "#FDAC41",
            borderWidth: 2,
            barThickness: 13,
            actualMonth: 1,
            borderColor: "#fff"
        },
        {
            backgroundColor: "#00CFDD",
            borderWidth: 2,
            barThickness: 13,
            actualMonth: 1,
            borderColor: "#fff"
        },
        {
            backgroundColor: "#5A8DEE",
            borderWidth: 2,
            barThickness: 13,
            actualMonth: 1,
            borderColor: "#fff"
        }
    ]
}

export const resourcesEquivalences = {
    VPC: "VPC",
    VPS: "VPS",
    FMP: "FID",
    ESG: "ESG",
    CT: "TC"
}